import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import type { Mapping } from '@/schemas/API/GET/mapping/response';

const useEmpTypeMapping = () => {
  const { data: empTypeMap } = useSWR<Mapping>(
    'mappings/employments',
    getFetcher
  );

  return empTypeMap;
};

export default useEmpTypeMapping;
